import { CSSProperties, memo } from 'preact/compat'
import { useRef, useEffect } from 'preact/hooks'

const convertToBase64 = (code: string) => {
  try {
    return atob(code)
  } catch {
    return null
  }
}

type Props = {
  code?: string
  styles?: CSSProperties
  className: string
  base64?: string
}

const Icon = (props: Props) => {
  const { base64 = true } = props
  const ref = useRef<HTMLDivElement>(null)
  const iconCode = base64 && props.code ? convertToBase64(props.code) : props.code

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = iconCode || ''
    }
  }, [ref])

  if (!props.code) return null

  return <div className={props.className} ref={ref} style={props.styles} />
}

export default memo(Icon)
